
//头颈及五官
export default {
	// 头颈及五官
    toujinglists : [
		{name:'头晕',title:''},
		{name:'颈项强直',title:''},
		{name:'头重',title:''},
		{name:'头痛',title:''},
		{name:'偏头痛',title:''},
		{name:'脑鸣',title:''},
		{name:'面色红',title:''},
		{name:'面色白',title:''},
		{name:'面色青',title:''},
		{name:'面色黧黑',title:''},
		{name:'面色萎黄',title:''},
		{name:'颜面浮肿',title:''},
		{name:'口眼喎斜',title:''},
		{name:'口苦',title:''},
		{name:'口臭',title:''},
		{name:'口淡',title:''},
		{name:'口干',title:''},
		{name:'口流涎',title:''},
		{name:'口唇青紫',title:''},
		{name:'牙痛',title:''},
		{name:'牙龈出血',title:''},
		{name:'耳聋',title:''},
		{name:'耳鸣',title:''},
		{name:'鼻塞',title:''},
		{name:'鼻流涕',title:''},
		{name:'鼻衄',title:''},
		{name:'咽干',title:''},
		{name:'喉痒',title:''},
		{name:'咽中异物感',title:''},
		{name:'胞睑肿胀',title:''},
		{name:'针眼',title:''},
		{name:'目干涩',title:''},
		{name:'头目胀痛',title:''},
		{name:'暴盲',title:''},
		{name:'夜盲',title:''},
		{name:'视瞻昏渺',title:''},
		{name:'口渴',title:''},
		{name:'口不渴',title:''},
		{name:'咽痛',title:''},
    ],
	// 胸腹
    xiongfu:[
      {name:'咳痰',title:''},
      {name:'咳嗽',title:''},
      {name:'咳血',title:''},
      {name:'气喘',title:''},
      {name:'哮鸣',title:''},
      {name:'胸痛',title:''},
      {name:'胸闷',title:''},
      {name:'心悸',title:''},
      {name:'心下痞',title:''},
      {name:'嗳气',title:''},
      {name:'吞酸',title:''},
      {name:'呃逆',title:''},
      {name:'恶心',title:''},
      {name:'嘈杂',title:''},
      {name:'呕吐',title:''},
      {name:'反胃',title:''},
      {name:'噎膈',title:''},
      {name:'纳呆',title:''},
      {name:'胃脘痛',title:''},
      {name:'厌食',title:''},
	  {name:'癥瘕',title:''},
      {name:'腹满',title:''},
      {name:'肠鸣',title:''},
      {name:'腹痛',title:''},
      {name:'胁痛',title:''},
      {name:'气短',title:''},
      {name:'烧心',title:''},
      {name:'怔忡',title:''},
      {name:'脘胀',title:''},
      {name:'胸骨后疼痛',title:''}

    ],
	// 四肢腰背
    sizhiyaobei:[
      {name:'肢体疼痛',title:''},
      {name:'肢体麻木',title:''},
      {name:'肢体肿胀',title:''},
      {name:'肢体拘急',title:''},
      {name:'肢体抽搐',title:''},
      {name:'肢体痿废',title:''},
      {name:'关节疼痛',title:''},
      {name:'关节变形',title:''},
      {name:'肩痛',title:''},
      {name:'腿痛',title:''},
      {name:'四肢无力',title:''},
      {name:'下肢浮肿',title:''},
      {name:'背痛',title:''},
      {name:'背冷',title:''},
      {name:'腰痛',title:''},
      {name:'腰酸',title:''},
      {name:'腰重',title:''},
      {name:'腰膝无力',title:''},
      {name:'腰冷',title:''},
      {name:'膝痛',title:''},
      {name:'颈痛',title:''},
      {name:'足跟痛',title:''},

    ],
	// 寒热
    hanre:[
      {name:'发热',title:''},
      {name:'潮热',title:''},
      {name:'壮热',title:''},
      {name:'低热',title:''},
      {name:'恶寒',title:''},
      {name:'寒战',title:''},
      {name:'寒热往来',title:''},
      {name:'手足心热',title:''},
      {name:'五心烦热',title:''},
      {name:'四肢厥逆',title:''},

    ],
	// 汗出
    hanchu:[
      {name:'自汗',title:''},
      {name:'盗汗',title:''},
      {name:'无汗',title:''},
      {name:'战汗',title:''},
      {name:'汗出偏沮',title:''},
      
    ],
	// 皮肤
    pifu:[
		{name:'瘙痒',title:''},
		{name:'脱屑',title:''},
		{name:'皲裂',title:''},
		{name:'风疹',title:''},
		{name:'水疱',title:''},
		{name:'脓疱',title:''},
		{name:'糜烂',title:''},
		{name:'萎缩',title:''},
		{name:'瘢痕',title:''},
		{name:'结节',title:''},
		{name:'红斑',title:''},
		{name:'紫斑',title:''},
		{name:'白斑',title:''},
		{name:'褐斑',title:''},
		{name:'肌肤甲错',title:''},
		{name:'痱子',title:''},
		{name:'湿疮',title:''},
		{name:'瘰疬',title:''},
    ],
	// 男女生殖
    nannvshengzhi:[
		{name:'遗精',title:''},
		{name:'早泄',title:''},
		{name:'阳痿',title:''},
		{name:'月经提前',title:''},
		{name:'月经后错',title:''},
		{name:'经行先后无定期',title:''},
		{name:'月经过多',title:''},
		{name:'月经过少',title:''},
		{name:'闭经',title:''},
		{name:'崩漏',title:''},
		{name:'经间期出血',title:''},
		{name:'经断前后诸症',title:''},
		{name:'白带',title:''},
		{name:'黄带',title:''},
		{name:'赤白带',title:''},
		{name:'妊娠呕吐',title:''},
		{name:'妊娠肿胀',title:''},
		{name:'妊娠眩晕',title:''},
		{name:'胎漏',title:''},
		{name:'胎动不安',title:''},
		{name:'乳汁不行',title:''},
		{name:'不孕',title:''},
    ],
	// 二便
    erbian:[
		{name:'腹泻',title:''},
		{name:'大便溏',title:''},
		{name:'里急后重',title:''},
		{name:'大便秘结',title:''},
		{name:'大便失禁',title:''},
		{name:'大便下血',title:''},
		{name:'小便黄赤',title:''},
		{name:'小便浑浊',title:''},
		{name:'小便清长',title:''},
		{name:'小便不利',title:''},
		{name:'小便频数',title:''},
		{name:'尿后余沥',title:''},
		{name:'小便失禁',title:''},
		{name:'夜间多尿',title:''},
		{name:'遗尿',title:''},
		{name:'小便疼痛',title:''},
		{name:'尿血',title:''},
    ],
	// 全身不适
    quanshenbushi:[
		{name:'乏力',title:''},
		{name:'身重',title:''},
		{name:'身痛',title:''},
		{name:'偏瘫',title:''},
		{name:'角弓反张',title:''},
		{name:'麻木',title:''},
		{name:'浮肿',title:''},
		{name:'肥胖',title:''},
		{name:'消瘦',title:''},
		{name:'发狂',title:''},
		{name:'癫痫',title:''},
		{name:'谵语',title:''},
		{name:'焦虑',title:''},
		{name:'抑郁',title:''},
		{name:'烦躁',title:''},
		{name:'嗜睡',title:''},
		{name:'痴呆',title:''},
		{name:'健忘',title:''},
		{name:'多梦',title:''},
		{name:'不寐',title:''},
		{name:'善太息',title:''},
		{name:'晕厥',title:''},
		{name:'易怒',title:''},
		{name:'瘫痪',title:''},




      
    ],
	// 体格体征表
    tigetizhengbiao:[
		{name:'检查时间',title:''},
		{name:'血压',title:''},
		{name:'呼吸',title:''},
		{name:'心率',title:''},
		{name:'体温',title:''},
		{name:'体重',title:''},
		{name:'身高',title:''},
		{name:'体格检查',title:''},
		// {name:'肥胖',title:''},  
    ],
	// 血常规
    xuechanggui:[
		{name:'红细胞计数',title:'',unit:"1012/L",unitRender:'<span class="label-unit">10<em>12</em>/L</span>'},
		{name:'白细胞计数',title:'',unit:"109/L",unitRender:'<span class="label-unit">10<em>9</em>/L</span>'},
		{name:'血小板计数',title:'',unit:"109/L",unitRender:'<span class="label-unit">10<em>9</em>/L</span>'},
		{name:'血红蛋白',title:'',unit:"g/L",unitRender:'<span class="label-unit">g/L</span>'},
		{name:'红细胞压积',title:'',unit:"109/L",unitRender:'<span class="label-unit">10<em>9</em>/L</span>'},
		{name:'中性粒细胞比率',title:'',unit:"%",unitRender:'<span class="label-unit">%</span>'},
		{name:'淋巴细胞比率',title:'',unit:"%",unitRender:'<span class="label-unit">%</span>'},
		{name:'单核细胞比率',title:'',unit:"%",unitRender:'<span class="label-unit">%</span>'},
		{name:'嗜酸粒细胞比率',title:'',unit:"%",unitRender:'<span class="label-unit">%</span>'},
		{name:'嗜碱性细胞比率',title:'',unit:"%",unitRender:'<span class="label-unit">%</span>'},		
		{name:'中性粒细胞数目',title:'',unit:"109/L",unitRender:'<span class="label-unit">10<em>9</em>/L</span>'},
		{name:'淋巴细胞数目',title:'',unit:"109/L",unitRender:'<span class="label-unit">10<em>9</em>/L</span>'},
		{name:'单核细胞数目',title:'',unit:"109/L",unitRender:'<span class="label-unit">10<em>9</em>/L</span>'},
		{name:'嗜酸粒细胞数目',title:'',unit:"109/L",unitRender:'<span class="label-unit">10<em>9</em>/L</span>'},
		{name:'嗜碱粒细胞数目',title:'',unit:"109/L",unitRender:'<span class="label-unit">10<em>9</em>/L</span>'},
		{name:'血小板压积',title:'',unit:"%",unitRender:'<span class="label-unit">%</span>'},
		{name:'平均血小板体积',title:'',unit:"fL",unitRender:'<span class="label-unit">fL</span>'},
		{name:'平均红细胞体积',title:'',unit:"fL",unitRender:'<span class="label-unit">fL</span>'},
		{name:'红细胞分布宽度变异系数',title:'',unit:"%",unitRender:'<span class="label-unit">%</span>'},
		{name:'红细胞分布宽度标准差',title:'',unit:"fL",unitRender:'<span class="label-unit">fL</span>'},
		{name:'平均红细胞血红蛋白含量',title:'',unit:"pg",unitRender:'<span class="label-unit">pg</span>'},
		{name:'血小板平均分布宽度',title:'',unit:"fL",unitRender:'<span class="label-unit">fL</span>'},
		{name:'平均红细胞血红蛋白浓度',title:'',unit:"g/L",unitRender:'<span class="label-unit">g/L</span>'},
		{name:'异常淋巴细胞百分比',title:'',unit:"%",unitRender:'<span class="label-unit">%</span>'},
		{name:'异常淋巴细胞数目',title:'',unit:"109/L",unitRender:'<span class="label-unit">%</span>'},
		{name:'巨大未成熟细胞百分比',title:'',unit:"%",unitRender:'<span class="label-unit">10<em>9</em>/L</span>'},
		{name:'巨大未成熟细胞数目',title:'',unit:"109/L",unitRender:'<span class="label-unit">10<em>9</em>/L</span>'},
    ],
	// 尿常规
    niaochanggui:[
		{name:'红细胞',title:'',unit:"细胞/μl",unitRender:'<span class="label-unit">细胞/μl<span'},
		{name:'白细胞',title:'',unit:"细胞/μl",unitRender:'<span class="label-unit">细胞/μl<span'},
		{name:'尿比重',title:'',unit:"SG",unitRender:'<span class="label-unit">SG<span'},
		{name:'酸碱度',title:'',unit:"PH",unitRender:'<span class="label-unit">PH<span'},
		{name:'尿蛋白',title:'',unit:"G/L(或定性",unitRender:'<span class="label-unit">G/L(或定性)<span'},
		{name:'葡萄糖',title:'',unit:"mmol/L",unitRender:'<span class="label-unit">mmol/L<span'},
		{name:'亚硝酸盐',title:'',unit:"mg/dL",unitRender:'<span class="label-unit">mg/dL<span'},
		{name:'酮体',title:'',unit:"mmol/L",unitRender:'<span class="label-unit">mmol/L<span'},
		{name:'胆红素',title:'',unit:"μmol/L",unitRender:'<span class="label-unit">μmol/L<span'},
		{name:'抗坏血酸',title:'',unit:"mg/100dL",unitRender:'<span class="label-unit">mg/100dL<span'},
		{name:'红细胞计数',title:'',unit:"μL",unitRender:'<span class="label-unit">μL<span'},
		{name:'白细胞计数',title:'',unit:"μL",unitRender:'<span class="label-unit">μL<span'},
		{name:'上皮细胞计数',title:'',unit:"μL",unitRender:'<span class="label-unit">μL<span'},
		{name:'管型计数',title:'',unit:"μL",unitRender:'<span class="label-unit">μL<span'},
		{name:'细菌',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'管型',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'结晶',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'小圆细胞',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'精子',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'真菌',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'红细胞信息',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'正常红细胞',title:'',unit:"%",unitRender:'<span class="label-unit">%<span'},
		{name:'正常红细胞计数',title:'',unit:"μL",unitRender:'<span class="label-unit">μL<span'},
		{name:'24小时尿蛋白定量',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
    ],
	// 大便常规
    dabianchanggui:[
		{name:'颜色',title:''},
		{name:'形状',title:''},
		{name:'性状镜检',title:''},
		{name:'白细胞',title:''},
		{name:'红细胞',title:''},
		{name:'潜血试验',title:''},
		{name:'虫卵',title:''},
		{name:'脂肪球',title:''},
		{name:'淀粉颗粒',title:''}
      
    ],
	// 血液生化
    xueyeshenghua:[
		{name:'钾',title:'',unit:"mmol/L",unitRender:'<span class="label-unit">mmol/L<span'},
		{name:'钠',title:'',unit:"mmol/L",unitRender:'<span class="label-unit">mmol/L<span'},
		{name:'氯',title:'',unit:"mmol/L",unitRender:'<span class="label-unit">mmol/L<span'},
		{name:'钙',title:'',unit:"mmol/L",unitRender:'<span class="label-unit">mmol/L<span'},
		{name:'磷',title:'',unit:"mmol/L",unitRender:'<span class="label-unit">mmol/L<span'},
		{name:'肌酐',title:'',unit:"umol/L",unitRender:'<span class="label-unit">umol/L<span'},
		{name:'尿酸',title:'',unit:"umol/L",unitRender:'<span class="label-unit">mmol/L<span'},
		{name:'胆固醇',title:'',unit:"mmol/L",unitRender:'<span class="label-unit">mmol/L<span'},
		{name:'甘油三酯',title:'',unit:"mmol/L",unitRender:'<span class="label-unit">mmol/L<span'},
		{name:'载脂蛋白A1',title:'',unit:"mmol/L",unitRender:'<span class="label-unit">g/L<span'},
		{name:'载脂蛋白B',title:'',unit:"g/L",unitRender:'<span class="label-unit">g/L<span'},
		{name:'脂蛋白(a)',title:'',unit:"g/L",unitRender:'<span class="label-unit">mg/L<span'},
		{name:'脂蛋白X',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'低密度脂蛋白胆固醇',title:'',unit:"mmol/L",unitRender:'<span class="label-unit">mmol/L<span'},
		{name:'高密度脂蛋白胆固醇',title:'',unit:"mmol/L",unitRender:'<span class="label-unit">mmol/L<span'},
		{name:'血清总蛋白测定',title:'',unit:"g/L",unitRender:'<span class="label-unit">g/L<span'},
		{name:'血清白蛋白测定',title:'',unit:"g/L",unitRender:'<span class="label-unit">g/L<span'},
		{name:'血清球蛋白测定',title:'',unit:"U/L",unitRender:'<span class="label-unit">U/L<span'},
		{name:'白蛋白/球蛋白',title:'',unit:"%",unitRender:'<span class="label-unit">%<span'},
		{name:'内生肌酐清除率',title:'',unit:"mL/min",unitRender:'<span class="label-unit">mL/min<span'},
		{name:'血β2-微球蛋白',title:'',unit:"μg/L",unitRender:'<span class="label-unit">μg/L<span'},
		{name:'血清碱性磷酸酶测定',title:'',unit:"U/L",unitRender:'<span class="label-unit">U/L<span'},
		{name:'血清总胆红素测定',title:'',unit:"mmol/L",unitRender:'<span class="label-unit">mmol/L<span'},
		{name:'血清直接胆红素测定',title:'',unit:"umol/L",unitRender:'<span class="label-unit">umol/L<span'},
		{name:'血清间接胆红素测定',title:'',unit:"umol/L",unitRender:'<span class="label-unit">umol/L<span'},
		{name:'血清丙氨酸氨基转移酶测定',title:'',unit:"U/L",unitRender:'<span class="label-unit">U/L<span'},
		{name:'天门冬氨酸氨基转移酶测定',title:'',unit:"U/L",unitRender:'<span class="label-unit">U/L<span'},
		{name:'血清r-谷氨酰基转肽酶测定',title:'',unit:"U/L",unitRender:'<span class="label-unit">U/L<span'},
    ],
	// 血糖
    xuetang:[
		{name:'空腹血糖',title:''},
		{name:'餐后0.5h血糖',title:''},
		{name:'餐后1h血糖',title:''},
		{name:'餐后2h血糖',title:''},
		{name:'糖化血红蛋白',title:''},
		{name:'随机血糖',title:''}, 
    ],
	// 凝血功能
    ningxuegongneng:[
		{name:'凝血酶原时间',title:'',unit:"秒",unitRender:'<span class="label-unit">秒<span'},
		{name:'凝血酶原活动度',title:'',unit:"%<",unitRender:'<span class="label-unit">%<span'},
		{name:'PT国际标准化比值',title:'',unit:"U/L",unitRender:'<span class="label-unit">U/L<span'},
		{name:'纤维蛋白原含量',title:'',unit:"g/L",unitRender:'<span class="label-unit">g/L<span'},
		{name:'凝血酶时间',title:'',unit:"秒",unitRender:'<span class="label-unit">秒<span'},
		{name:'活化部分凝血活酶时间',title:'',unit:"秒",unitRender:'<span class="label-unit">秒<span'},

    ],
	// 血液流变学检验
    xueyeliubianxue:[
		{name:'全血黏度值',title:''},
		{name:'血浆黏度值',title:''},
		{name:'血细胞比容',title:''},
		{name:'全血高切还原黏度',title:''},
		{name:'全血低切还原黏度',title:''},
		{name:'全血低切相对黏度',title:''},
		{name:'全血低切相对黏度',title:''},
		{name:'红细胞变性指数',title:''},
    ],
	// 心脏和肌肉疾病相关检查
    xinzanghejirou:[
		{name:'尿肌酸',title:'',unit:"μmol/24小时尿",unitRender:'<span class="label-unit">μmol/24小时尿<span'},
		{name:'肌钙蛋白T',title:'',unit:"μg/L",unitRender:'<span class="label-unit">μg/L<span'},
		{name:'肌钙蛋白 I',title:'',unit:"μg/L",unitRender:'<span class="label-unit">μg/L<span'},
		{name:'血肌红蛋白',title:'',unit:"μg/L",unitRender:'<span class="label-unit">μg/L<span'},
		{name:'乳酸脱氢酶测定',title:'',unit:"LDH",unitRender:'<span class="label-unit">LDH<span'},
		{name:'α-羟丁酸脱氢酶',title:'',unit:"U/L",unitRender:'<span class="label-unit">U/L<span'},
		{name:'血清肌酸激酶测定',title:'',unit:"U/L",unitRender:'<span class="label-unit">U/L<span'},
		{name:'血清肌酸激酶-MB同功酶测定',title:'',unit:"U/L",unitRender:'<span class="label-unit">U/L<span'},
		{name:'血清肌酸激酶-MB同功酶测定',title:'',unit:"U/L",unitRender:'<span class="label-unit">U/L<span'},
      
    ],
	// 微量元素检测
    weiliangyuansu:[
		{name:'血清铁',title:'',unit:"μmol/L",unitRender:'<span class="label-unit">μmol/L<span'},
		{name:'血清铜',title:'',unit:"μmol/L",unitRender:'<span class="label-unit">μmol/L<span'},
		{name:'血清锌',title:'',unit:"μmol/L",unitRender:'<span class="label-unit">μmol/L<span'},
		{name:'血清硒',title:'',unit:"μmol/L",unitRender:'<span class="label-unit">μmol/L<span'},
		{name:'血清碘',title:'',unit:"μmol/L",unitRender:'<span class="label-unit">μmol/L<span'},
		{name:'血清铅',title:'',unit:"mg/L",unitRender:'<span class="label-unit">mg/L<span'},
		{name:'血清铬',title:'',unit:"μmol/L",unitRender:'<span class="label-unit">μmol/L<span'},
		{name:'血清锰',title:'',unit:"mmol/L",unitRender:'<span class="label-unit">mmol/L<span'},
		{name:'总铁结合力',title:'',unit:"μmol/L",unitRender:'<span class="label-unit">μmol/L<span'},
      
    ],
	// 血气分析表
    xueqifenxi:[
		{name:'动脉血氧分压',title:'',unit:"Kpa",unitRender:'<span class="label-unit">Kpa<span'},
		{name:'动脉血二氧化碳分压',title:'',unit:"Kpa",unitRender:'<span class="label-unit">Kpa<span'},
		{name:'动脉血氧饱和度',title:'',unit:"%",unitRender:'<span class="label-unit">%<span'},
		{name:'血液酸碱度',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'实际碳酸氢根',title:'',unit:"mmol/L",unitRender:'<span class="label-unit">mmol/L<span'},
		{name:'标准碳酸氢根',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'全血缓冲碱',title:'',unit:"mmol/L",unitRender:'<span class="label-unit">mmol/L<span'},
		{name:'二氧化碳结合力',title:'',unit:"mmol/L",unitRender:'<span class="label-unit">mmol/L<span'},
		{name:'剩余碱',title:'',unit:"mmol/L",unitRender:'<span class="label-unit">mmol/L<span'},
    ],
	// 激素和内分泌检查
    jisu:[
		{name:'孕酮',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'睾酮',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'催乳素',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'促黄体生成素',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'雌二醇测定',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'促卵泡生成激素',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'尿醛固酮',title:'',unit:"μg/24小时尿",unitRender:'<span class="label-unit">μg/24小时尿<span'},
		{name:'血浆皮质醇',title:'',unit:"ng/L",unitRender:'<span class="label-unit">ng/L<span'},
		{name:'血浆醛固酮',title:'',unit:"ng/L",unitRender:'<span class="label-unit">ng/L<span'},
		{name:'游离甲状腺素',title:'',unit:"pmol/L",unitRender:'<span class="label-unit">pmol/L<span'},
		{name:'超敏促甲状腺素',title:'',unit:"uIU/ml",unitRender:'<span class="label-unit">uIU/ml<span'},
		{name:'甲状腺球蛋白抗体',title:'',unit:"%",unitRender:'<span class="label-unit">%<span'},
		{name:'甲状腺微粒体抗体',title:'',unit:"%",unitRender:'<span class="label-unit">%<span'},
		{name:'游离三碘甲状腺原氨酸',title:'',unit:"pmol/L",unitRender:'<span class="label-unit">pmol/L<span'},
		{name:'尿17-酮类固醇测定',title:'',unit:"μmol/24小时尿",unitRender:'<span class="label-unit">μmol/24小时尿<span'},
		{name:'尿17-羟皮质类固醇测定',title:'',unit:"μmol/24小时尿",unitRender:'<span class="label-unit">μmol/24小时尿<span'},
    ],
	// 肿瘤标志物检测
    zhongliubiaozhiwu:[
		{name:'甲胎蛋白',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'CA胚抗原',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'糖类抗原125',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'糖类抗原15-3',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'糖类抗原19-9',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'尿中巯基测定',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'前列腺特异抗原',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
    ],
	// 病毒性肝炎免疫标志物检测
    bingduxing:[
		{name:'乙肝表面抗原',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'乙肝表面抗体',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'乙型肝炎e抗原',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'乙型肝炎e抗体',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'乙型肝炎核心抗体',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'甲型肝炎抗体',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'丙型肝炎抗体',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
    ],
	// 自身抗体检测
    zishenkangti:[
		{name:'ANA抗体筛查',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'ANA定量检测',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'抗DNP抗体',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'抗双链DNA抗体',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'抗核小体抗体',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'抗SmD1抗体',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'抗核糖体P蛋白抗体',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'抗组蛋白抗体',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'抗U1-snRNP抗体',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'抗SSA-60KD抗体',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'抗SSA-52KD抗体',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'抗SSB抗体',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'抗Scl-70抗体',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'抗着丝点抗体',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
		{name:'抗Jo-1抗体',title:'',unit:"",unitRender:'<span class="label-unit"><span'},
    ],
} 

